<template>
    <div class="draw">
        <div class="item-detail-wrapper" @click="clickCampaign()">
            <div class="item-detail">
                <div class="detail-header">
                    <img :src="campaign.fullImageUrl" />
                </div>
                <div class="detail-point mt-2">ใช้ {{campaign.pointPerUnit}} คะแนน</div>
                <div class="title-campaign">{{campaign.name}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js"

export default {
    name: 'CampaignItem',
    props: {
        lbl: Object,
        index: Number,
        campaign: Object
    },
    data: function() {
        return {
            lblCampaign: this.lbl.campaign
        };
    },
    created: function() {
        
    },
    mounted: function () {
        //this.lblCampaign = this.lbl.campaign;
    },
    methods: {
        //event
        clickCampaign: function () {
            //GA
            var path = '/campaign/' + this.campaign.id;
            this.$router.push(path);
        },
        //method
        isSoldOut: function () {
            return this.campaign.qty < 1 
                ? true
                : false 
        },
        //utility
        getPointMessage: function () {
            var pointType = this.campaign.pointType == 'get' ? this.lblCampaign.get_point : this.lblCampaign.use_point;
            var pointUnit = this.lblCampaign.point + (this.campaign.pointPerUnit > 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
            return pointType + " " + this.campaign.pointPerUnit + " " + pointUnit;
        }
    },
}
</script>
<style lang="scss" scoped>
@import "./campaignlist.scss";
.draw {
.item-detail-wrapper {
    padding-top: 100px;
}
.item-detail {
    border-radius: 15px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    margin-bottom: 15px;
    padding: 15px;
    position: relative;
    .detail-header {
        // @include baseRatioImg(66.66%);
        img {
            border-radius: 20px;
            width: 100%;
            border: 0;
        }
        margin-top: -120px;
        overflow: unset;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
        border-radius: 20px;
    }
    .detail-description {
        margin-top: 10px;
        line-height: 1;
        // @extend %ellipsis-2;
    }
    .detail-footer {
        position: absolute;
        right: 20px;
        bottom: -15px;
        .btn-detail {
            border-radius: 5px;
            box-shadow: 0 3px 6px 0 rgba(255, 255, 255, 0.42);
            background-color: #ec1d23;
            color: #fff;
            font-size: 1.4rem;
            padding: 0 10px;
            min-width: 140px;
            text-align: center;
        }
    }
}
}
</style>
